import { CalHeatMap } from './cal-heatmap';

require('./heatmap.component.scss');

function HeatmapController(
  $scope,
  $element,
  RouterService,
) {
  $scope.router = RouterService;
  $scope.render = function () {
    $element.find('svg').remove();
    let calendar = new CalHeatMap();
    let activity = $scope.activity;
    if (!activity) return;
    let days = activity.filter.days;
    let stump = function (cell) {
      if (!cell) return new Date();
      return new Date(
        cell['agent_time.year'],
        cell['agent_time.month'] - 1,
        cell['agent_time.day'],
        cell['agent_time.hour'],
        (days === 1) ? cell['agent_time.minute'] : 0,
      );
    };
    let parser = function (cells) {
      let stats = {};
      for (let i in cells) {
        let cell = cells[i];
        let at = cell['activity_time_sum'];
        let it = cell['idle_time_sum'];
        let rc = cell['record_count'];
        let st = String(stump(cell).getTime() / 1000);
        stats[st] = rc;
      }
      return stats;
    };
    $('#report-canvas').empty();
    if (days === 1) {
      let startDate = activity.filter.timeFrom;
      //let startDate = stump( aggregate.cells[ 0 ] );
      //startDate = new Date( startDate.getTime() - 1000 * 60 * 60 * 24 );
      let cellSize = Math.round(($element.parent().width() - 50) / 61) - 1;
      if (cellSize < 2) return;
      $('.hours').hide();
      calendar.init({
        itemSelector       : '#report-canvas',
        scale              : [1, 2, 4, 8, 16, 32, 64, 128, 256, 512],
        legend             : [1, 2, 4, 8, 16, 32, 64, 128, 256, 512],
        data               : parser(activity.cells),
        start              : startDate,
        range              : 24,
        colLimit           : 60,
        cellSize           : cellSize,
        cellPadding        : 1,
        tooltip            : true,
        domain             : 'hour',
        subDomain          : 'min',
        browsing           : true,
        verticalOrientation: true,

        onClick: function (now, count) {
          $scope.$apply(function () {
            $scope.router.addTimeFilter(now, 5, true); // Add time filter with 4 levels
            $scope.router.mode = 'explore';
            $scope.filterBar.setDrilldown(
              'agent_eventtype@default:agent_eventtype');
            $scope.$emit('reload');
          });
        },
      });
    } else {
      let startDate = activity.filter.timeTo || stump(activity.cells[0]);
      startDate = new Date(startDate.getTime() - 1000 * 60 * 60 * 24 * (days - 1));
      let cellSize = Math.round(($element.parent().width() - 50) / 24);
      if (cellSize < 10) return;
      $('.hours').show();
      $('.hours').find('span').width(cellSize - 2);
      // Limit memory usage
      calendar.init({
        itemSelector       : '#report-canvas',
        scale              : [
          256,
          1024,
          4096,
          8192,
          16376,
          32768,
          65536,
          131072,
          262144,
        ],
        legend             : [
          256,
          1024,
          4096,
          8192,
          16376,
          32768,
          65536,
          131072,
          262144,
        ],
        data               : parser(activity.cells),
        start              : startDate,
        range              : days, // Number of days to display
        cellSize           : (cellSize - 4),
        cellPadding        : 2,
        colLimit           : 24,
        domainMargin       : [0, 0, 0, 0],
        verticalOrientation: true,
        reverse            : true,
        tooltip            : true,
        domain             : 'day',
        subDomain          : 'hour',
        browsing           : true,
        onClick            : function (now, count) {
          $scope.$apply(function () {
            $scope.router.addTimeFilter(now, 4, true); // Add time filter with 4 levels
            $scope.router.mode = 'explore';
            $scope.filterBar.setDrilldown(
              'agent_eventtype@default:agent_eventtype');
          });
        },
      });
    }
    $('.report-time').removeClass('ng-hide');
  };
  $scope.$watch('activity', function () {
    $scope.render();
  });
}

export function HeatmapComponent() {
  return {
    restrict: 'E',
    template: require('./heatmap.component.html'),
    scope   : {
      filter   : '<',
      filterBar: '<',
      activity : '<',
    },

    controller: HeatmapController,
  };
}



// WEBPACK FOOTER //
// ./src/facts/heatmap/heatmap.component.js